import { RootState } from '../redux';

export const selectAccessToken = (state: RootState) => state.auth.accessToken;

export const selectRefreshToken = (state: RootState) => state.auth.refreshToken;

export const selectIsAuthorized = (state: RootState) =>
  Boolean(selectAccessToken(state));

export const selectRememberMe = (state: RootState) => state.auth.rememberMe;

export const selectMustSetPassword = (state: RootState) => state.auth.mustSetPassword;

export const selectPrivacyPolicyAccepted = (state: RootState) => state.auth.privacyPolicyAccepted;
